import React from 'react';

const HEIGHTS = [35, 60, 80, 50, 90, 65, 45, 75, 55, 85, 40, 70, 95, 60, 50, 80, 45, 65, 75, 55, 90, 40, 70, 60, 85];

const WaveformBars = ({ isPlaying = false, count = 25, height = 48, color = 'gradient' }) => {
  const bars = HEIGHTS.slice(0, count);

  return (
    <div
      data-testid="waveform-bars"
      className="flex items-center gap-[3px]"
      style={{ height }}
    >
      {bars.map((h, i) => (
        <div
          key={i}
          className={`rounded-full flex-shrink-0 transition-all ${
            color === 'gradient' ? 'bg-gradient-to-t from-blue-500 to-purple-500' : 'bg-primary'
          }`}
          style={{
            width: '3px',
            height: isPlaying ? undefined : `${h}%`,
            animation: isPlaying ? `waveBar ${0.7 + (i % 5) * 0.15}s ease-in-out infinite alternate` : 'none',
            animationDelay: isPlaying ? `${(i * 0.05) % 0.5}s` : '0s',
            minHeight: '4px',
          }}
        />
      ))}
    </div>
  );
};

export default WaveformBars;
